import { openNewTab } from '@blockworks/platform/utils';
import { FlexBox, IconButton } from '@blockworks/ui/components';
import { toast } from '@blockworks/ui/toast';

import { ISocialSharingLinks } from '@/utils/url';

import { WebTableOfContents } from './table-of-contents';

const ArticleSharing = ({ articleSharingLinks }: { articleSharingLinks: ISocialSharingLinks[] }) => {
    const handleCopyToCB = (copyToClipboard: boolean, url: string) => () => {
        if (copyToClipboard) {
            navigator.clipboard.writeText(url);
            toast.info('Link copied to clipboard');
        } else {
            openNewTab(url);
        }
    };
    return (
        <div className="sticky top-6 print:hidden">
            <WebTableOfContents />
            <FlexBox gap="sm" mt={2} center>
                {articleSharingLinks?.map(
                    ({ icon, name, url, copyToClipboard }) =>
                        icon && (
                            <IconButton
                                key={`social-${name}`}
                                aria-label={`${name}`}
                                variant="ghost"
                                size="md"
                                icon={icon}
                                onClick={handleCopyToCB(!!copyToClipboard, url)}
                            />
                        ),
                )}
            </FlexBox>
        </div>
    );
};

export default ArticleSharing;
